import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	skipToRightSidePanel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	skipToRightSidePanel: {
		id: 'projects-directory-templates-sidebar.skip-link.skip-to-right-side-panel',
		defaultMessage: 'Skip to Side Panel',
		description:
			'Accessibility title for skipping to the Jira Project List side panel section of Jira. Shows when tabbing first time on a page',
	},
});
export default messages;
